import { reduxActionTypePrefix } from "../../../constants/module.constants.js";
const prefix = `${reduxActionTypePrefix}/CREATE`;
export {
  prefix
};
//# sourceMappingURL=constants.js.map
